(function () {
  function step(items, dir) {
    var i = items.findIndex(function (el) { return el.classList.contains('is-active') || el.classList.contains('active'); });
    if (i < 0) i = 0;
    return items[(i + dir + items.length) % items.length];
  }
  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    var nav = gallery.querySelector('[data-cadris-gallery-nav]');
    if (!nav) return;
    var go = function (dir) {
      var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-list > .product__media-item[data-media-id]'));
      if (items.length < 2) return;
      var next = step(items, dir);
      gallery.setActiveMedia(next.dataset.mediaId, false);
    };
    nav.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); go(parseInt(b.dataset.dir, 10)); });
    });
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });
  });
  document.querySelectorAll('product-modal').forEach(function (modal) {
    var nav = modal.querySelector('[data-cadris-modal-nav]');
    if (!nav) return;
    var go = function (dir) {
      var items = Array.prototype.slice.call(modal.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      if (items.length < 2) return;
      var next = step(items, dir);
      items.forEach(function (el) { el.classList.remove('active'); });
      next.classList.add('active');
      modal.querySelector('.product-media-modal__content').scrollTop = 0;
    };
    nav.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(parseInt(b.dataset.dir, 10)); });
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });
  });
})();
